/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'ai-summary-label': '总结',
  'copy-content-link-label': '复制链接',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': '开始输入以搜索标签',
  'dynamic-cards-search-page.app-filter-sidebar.all': '全部',
  'dynamic-cards-search-page.app-filter-sidebar.group': '按产品筛选搜索',
  'dynamic-cards-search-page.atlas.for': '对于',
  'dynamic-cards-search-page.avatar': '头像',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': '日历',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': '加入会议',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': '会议链接',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': '加入会议',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': '既往事件',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': '重复事件',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': '重复执行',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': '即将发生的事件',
  'dynamic-cards-search-page.compass.owner-name': '负责人：{ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': '层级：{tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': '查找内容',
  'dynamic-cards-search-page.confluence.filter.content.selected': '已选',
  'dynamic-cards-search-page.confluence.filter.content.unselected': '建议',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': '已选',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': '建议',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': '查找人员',
  'dynamic-cards-search-page.confluence.filter.label.selected': '已选',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': '查找标签',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': '查找空间',
  'dynamic-cards-search-page.connect_third_party_product_description': '连接您的帐户以查看缺失的结果',
  'dynamic-cards-search-page.connect_third_party_product_title': '您的管理员已添加 {product}！',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} 现已推出！',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': '起始日期必须早于截止日期',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': '起始日期不能是未来日期',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': '结束日期不能是未来日期',
  'dynamic-cards-search-page.date.filter.last.month': '过去 30 天',
  'dynamic-cards-search-page.date.filter.last.week': '过去 7 天',
  'dynamic-cards-search-page.date.filter.last.year': '去年',
  'dynamic-cards-search-page.document-search-result.google-slides-label': '幻灯片',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': '生成回答',
  'dynamic-cards-search-page.dropdown_recent_icon_label': '最近',
  'dynamic-cards-search-page.error_primary': '搜索时遇到问题',
  'dynamic-cards-search-page.error_secondary': '可能出了一点小问题。最好<btn>重试</btn>。',
  'dynamic-cards-search-page.externalPeopleLabel': '外部人员 #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': '清除筛选器',
  'dynamic-cards-search-page.filter.last.updated.anytime': '任何时间',
  'dynamic-cards-search-page.filter.last.updated.past30Days': '过去 30 天',
  'dynamic-cards-search-page.filter.last.updated.past7Days': '过去 7 天',
  'dynamic-cards-search-page.filter.last.updated.pastYear': '去年',
  'dynamic-cards-search-page.filter.last.updated.today': '今天',
  'dynamic-cards-search-page.filter.last.updated.yesterday': '昨天',
  'dynamic-cards-search-page.filter.type.answer': '回答',
  'dynamic-cards-search-page.filter.type.attachment': '附件',
  'dynamic-cards-search-page.filter.type.blogpost': '博客文章',
  'dynamic-cards-search-page.filter.type.branch': '分支',
  'dynamic-cards-search-page.filter.type.calendar': '日历',
  'dynamic-cards-search-page.filter.type.comment': '评论',
  'dynamic-cards-search-page.filter.type.commit': '提交',
  'dynamic-cards-search-page.filter.type.component': '组件',
  'dynamic-cards-search-page.filter.type.conversation': '对话',
  'dynamic-cards-search-page.filter.type.database': '数据库',
  'dynamic-cards-search-page.filter.type.design': '设计',
  'dynamic-cards-search-page.filter.type.documents': '文档',
  'dynamic-cards-search-page.filter.type.issue': '事务',
  'dynamic-cards-search-page.filter.type.message': '消息',
  'dynamic-cards-search-page.filter.type.page': '页面',
  'dynamic-cards-search-page.filter.type.placeholder': '查找类型',
  'dynamic-cards-search-page.filter.type.presentation': '演示文稿',
  'dynamic-cards-search-page.filter.type.pull-request': '拉取请求',
  'dynamic-cards-search-page.filter.type.question': '问题',
  'dynamic-cards-search-page.filter.type.repository': '存储库',
  'dynamic-cards-search-page.filter.type.space': '空间',
  'dynamic-cards-search-page.filter.type.space-calendar': '空间日历',
  'dynamic-cards-search-page.filter.type.spreadsheet': '电子表格',
  'dynamic-cards-search-page.filter.type.video': '视频',
  'dynamic-cards-search-page.filter.type.web-page': '网页',
  'dynamic-cards-search-page.filter.type.whiteboard': '白板',
  'dynamic-cards-search-page.filters.dropdown.clear-all': '全部清除',
  'dynamic-cards-search-page.filters.dropdown.title': '筛选器',
  'dynamic-cards-search-page.filters.names.content': '内容所在位置',
  'dynamic-cards-search-page.filters.names.contributor': '贡献者',
  'dynamic-cards-search-page.filters.names.labels': '标签',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': '标题匹配',
  'dynamic-cards-search-page.github-branch-result.label': '分支',
  'dynamic-cards-search-page.github-commit-result.label': '提交',
  'dynamic-cards-search-page.github-pull-request-result.label': '拉取请求',
  'dynamic-cards-search-page.jira.filter.project.placeholder': '查找项目',
  'dynamic-cards-search-page.landing_primary': '开始为动态卡片使用筛选器',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': '文档',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': '电子表格',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': '未找到与您的搜索匹配的任何内容',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    '您似乎已应用某些筛选器。您可以试着清除这些筛选器。',
  'dynamic-cards-search-page.nouns.goal': '目标',
  'dynamic-cards-search-page.nouns.goals': '目标',
  'dynamic-cards-search-page.nouns.tag': '标记',
  'dynamic-cards-search-page.nouns.tags': '标记',
  'dynamic-cards-search-page.number_of_results': '显示 {numberOfResults,number} 条结果，共 {totalCount,number} 条',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': '{product} 的授权失败。',
  'dynamic-cards-search-page.oauth-banner.authorization-success': '{product} 的授权成功。',
  'dynamic-cards-search-page.oauth-message-connect': '连接',
  'dynamic-cards-search-page.products.custom-website': '网页',
  'dynamic-cards-search-page.results-sort.createdDate.selected': '按创建时间排序（从最新到最旧）',
  'dynamic-cards-search-page.results-sort.createdDateDESC': '创建时间（最新到最旧）',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': '更新时间（最新到最旧）',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': '按更新时间排序（从最新到最旧）',
  'dynamic-cards-search-page.results-sort.sort-options.label': '更改列表排序方式',
  'dynamic-cards-search-page.rovo-onboarding-dismiss': '关闭',
  'dynamic-cards-search-page.rovo-onboarding-next': '下一步',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description': '按产品筛选以获得更相关的搜索结果。',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': '在您公司的所有工作区中搜索',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    '根据您筛选的产品，这些选项会发生更改，以帮助您获得具体的结果。',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': '找到您想要的确切内容',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': '附件',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': '附加日期：{formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': '音频',
  'dynamic-cards-search-page.search-result.attachments.image-label': '图像',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': '更新时间：{formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': '私有通道',
  'dynamic-cards-search-page.search-result.remove-recent-search': '“移除最近搜索”图标',
  'dynamic-cards-search-page.search-result.repository-label': '存储库',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {与外部用户的群组消息} =2 {{name1} 和 {name2}} =3 {{name1}、{name2} 和 {name3}} =4 {{name1}、{name2}、{name3} 和另外 {overflowContributorCount} 个} other {{name1}、{name2}、{name3} 和另外 {overflowContributorCount} 人}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': '未知通道',
  'dynamic-cards-search-page.search_result_type_answer': '回答',
  'dynamic-cards-search-page.search_result_type_card': '卡片',
  'dynamic-cards-search-page.search_result_type_component': '组件',
  'dynamic-cards-search-page.search_result_type_document': '文档',
  'dynamic-cards-search-page.search_result_type_embed': '智能链接',
  'dynamic-cards-search-page.search_result_type_folder': '文件夹',
  'dynamic-cards-search-page.search_result_type_presentation': '演示文稿',
  'dynamic-cards-search-page.search_result_type_pull_request': '拉取请求',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Sharepoint 文档',
  'dynamic-cards-search-page.search_result_type_space_calendar': '空间日历',
  'dynamic-cards-search-page.search_result_type_spreadsheet': '电子表格',
  'dynamic-cards-search-page.search_result_type_unrecognised': '未辨识',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    '您的管理员已添加 <strong>{product}！</strong>{br}请连接您的帐户以查看缺失的结果，包括只有您有权访问的文档。',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} 现已推出！</strong>{br}请连接您的帐户以查看缺失的结果，包括只有您有权访问的文档。',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': '授权',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': '{product} 的授权失败。',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': '{product} 的授权成功。',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': '按所有应用筛选',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': '按更多应用筛选',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': '已归档',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': '有风险',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': '已取消',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': '已完成',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': '异常',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': '正常',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': '已暂停',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': '待处理',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, other {此视频中的 {chapterCount,number} 个章节}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': '视频图标',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': '视频缩略图',
  'dynamic-cards-search-page.work-item-assignee.assigned': '已被指派',
  'dynamic-cards-search-page.work-item-creator.created': '已创建',
  'dynamic-cards-search-page.work-item-status.for': '-',
  'dynamic-cards-search-page.work-item-ticket.label': '工作单',
  'dynamic-cards-search-page.work-item.label': '工作项',
  'initialsAvatar.label': '姓名缩写头像',
  'personAvatar.label': '人员头像',
  'search-page.results.private-result-label': '私有',
  'search-page.results.private-result-tooltip': '仅对您可见',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, other {{memberCount,number} 个成员}}',
  'search-page.results.product-results.third-party.channel-type-label': '通道',
  'search-page.results.product-results.third-party.conversation-search-result.label': '通道',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, other {{count,number} 个成员}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    '上次活跃时间：{formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': '未知通道',
  'search-page.results.product-results.third-party.external-people-label': '外部人员',
  'search-page.results.product-results.third-party.external-person-label': '外部人员',
  'search-page.results.product-results.third-party.last-active': '上次活跃时间：{relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': '消息',
  'search-page.results.product-results.third-party.no-contributors-label': '#{channelName} 中的外部人员',
  'search-page.results.product-results.third-party.private-conversation-text': '私有对话中的{users}',
  'search-page.results.product-results.third-party.thread-type-label': '主题',
  'search-page.results.product-results.third-party.title-and-channel-name': '"#{channelName}" 中的 "{title}"',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, other {{title} 和另外 {remainingContributorsCount} 人}}',
  'search-page.results.restricted-result-label': '受限',
  'search-page.results.restricted-result-tooltip': '仅对特定人员可见',
  'search-page.show-more-breadcrumbs-button-label': '显示更多导航项',
  'search-page.verified-icon-label': '已验证',
  'search-page.verified-icon-tooltip-message': '此页面已由负责人或管理员验证。',
  'search-result.result.count': '{count, plural, other {显示 {count} 条结果}}',
  'search-result.user-mention.external-person': '外部人员',
};
